export default {"src":"/_next/static/media/right_arrow_blue.45be6ff9.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};